require("!!/home/selvam/projects/compare-my-religion/frontend/node_modules/script-loader/addScript.js")(require("!!/home/selvam/projects/compare-my-religion/frontend/node_modules/raw-loader/index.js!/home/selvam/projects/compare-my-religion/frontend/node_modules/handsontable/dist/handsontable.full.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/handsontable/dist/handsontable.full.js
// module id = 389
// module chunks = 12